import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import BcReactComponent from '@bibliocommons/base-bc-react-component';
import HelpLink from '@bibliocommons/shared-help-link';

export class HelpLinkContainer extends BcReactComponent {
  render() {
    const { className, page, currentLanguage, showIcon, children } = this.props;

    return (
      <HelpLink className={className} page={page} currentLanguage={currentLanguage} showIcon={showIcon} >
        {children}
      </HelpLink>
    );
  }
}

HelpLinkContainer.propTypes = {
  className: PropTypes.string,
  page: PropTypes.string.isRequired,
  currentLanguage: PropTypes.string,
  showIcon: React.PropTypes.bool
};

const mapStateToProps = (state) => ({
  currentLanguage: state.getIn(['localization', 'currentLanguage'])
});

export default connect(mapStateToProps)(HelpLinkContainer);



// WEBPACK FOOTER //
// ./app/containers/HelpLinkContainer.jsx